import { ArrowUpRight, Bell, QrCode } from "lucide-react";

export default function PhoneMockup() {
    return (
        <div className="relative mx-auto w-[280px] sm:w-[300px]">
            <div className="animate-float rounded-[2.75rem] border-[10px] border-gr-ink bg-gr-ink p-1 shadow-2xl dark:border-black">
                <div className="relative overflow-hidden rounded-[2.1rem] bg-gr-bg dark:bg-gr-dsurface">
                    <div className="absolute left-1/2 top-2 z-10 h-6 w-28 -translate-x-1/2 rounded-full bg-gr-ink dark:bg-black" />
                    <div className="space-y-4 p-5 pt-10">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="font-mono text-[10px] uppercase tracking-widest text-gr-accent">Dzień dobry</p>
                                <p className="font-heading text-lg font-extrabold text-gr-ink dark:text-gr-dink">Anna K.</p>
                            </div>
                            <div className="grid h-9 w-9 place-items-center rounded-full bg-gr-secondary dark:bg-gr-dsecondary">
                                <Bell className="h-4 w-4 text-gr-primary dark:text-gr-dprimary" />
                            </div>
                        </div>

                        <div className="rounded-2xl bg-gr-primary p-4 text-white">
                            <p className="text-xs opacity-80">Do zapłaty w tym miesiącu</p>
                            <p className="font-mono text-2xl font-bold">2 149,32 zł</p>
                            <div className="mt-3 flex items-center gap-2 text-xs">
                                <QrCode className="h-4 w-4" />
                                <span>QR do ZUS gotowy</span>
                            </div>
                        </div>

                        <div className="space-y-2">
                            {[
                                { t: "Faktura FV/2026/044", s: "Wysłana do KSeF", v: "+1 230 zł", ok: true },
                                { t: "Paragon — Orlen", s: "OCR: koszt paliwa", v: "−287 zł", ok: false },
                                { t: "VAT-OSS — DE", s: "Rozliczone", v: "19%", ok: true },
                            ].map((r) => (
                                <div key={r.t} className="flex items-center justify-between rounded-xl border border-gr-line bg-gr-surface p-3 dark:border-gr-dline dark:bg-gr-dsurface2">
                                    <div>
                                        <p className="text-xs font-semibold text-gr-ink dark:text-gr-dink">{r.t}</p>
                                        <p className="text-[10px] text-gr-sub dark:text-gr-dsub">{r.s}</p>
                                    </div>
                                    <span className={`font-mono text-xs font-bold ${r.ok ? "text-success" : "text-gr-sub dark:text-gr-dsub"}`}>{r.v}</span>
                                </div>
                            ))}
                        </div>

                        <div className="flex items-center justify-center gap-1.5 rounded-xl bg-gr-accent/15 py-2.5 text-xs font-semibold text-gr-primary dark:text-gr-dprimary">
                            Zapytaj AI Doradcę <ArrowUpRight className="h-3.5 w-3.5" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
